export const CustomersDetailsDemoData = {
    id: 1,
    firstName: 'Date',
    lastName: 'PHP',
    fullName: 'Date PHP',
    organization: 'Bikiran',
    primaryEmail: 'datephp@gmail.com',
    primaryPhone: '019256466934',
    primaryAddress: '',
    role: 'agency',
    status: 'active',
    photoUrl: 'https://storage.googleapis.com/miracle-bucket-23/profile_images/profile.jpg',
    note: 'updated',
    applications: [
        {
            id: 70,
            subscriptionName: 'HRCT - Purchase',
            domain: 'yeasin.net',
            timeSubscriptionStart: 1702214621,
            timeSubscriptionEnd: 1733837021,
            currentVersion: '',
            installedVersion: '',
            status: 'active',
            userId: 1,
            timeFirstInstallation: 0,
            timeClientUpdate: 0,
            customerInfo: null,
            demo: true
        },
        {
            id: 71,
            subscriptionName: 'Digital Experience Checkup -ABC',
            domain: '',
            timeSubscriptionStart: 1702214804,
            timeSubscriptionEnd: 1710077204,
            currentVersion: '',
            installedVersion: '',
            status: 'active',
            userId: 1,
            timeFirstInstallation: 0,
            timeClientUpdate: 0,
            customerInfo: null,
            demo: true
        }
    ],
    addresses: {
        administrative: null,
        billing: null,
        technical: null
    },
    address: '---------------',
    invoices: [
        {
            id: 106,
            currency: 'USD',
            firstName: 'Yeasin',
            lastName: 'Arafat',
            phone: '8801795617763',
            email: 'yeasinn2002@gmail.com',
            invoiceTitle: 'HRCT - Purchase',
            timeIssue: 1702214606,
            timeDue: 1702322606,
            amountBilled: 240,
            amountPaid: 240,
            demo: true
        },
        {
            id: 107,
            currency: 'USD',
            firstName: 'Yeasin',
            lastName: 'Arafat',
            phone: '8801795617763',
            email: 'yeasinn2002@gmail.com',
            invoiceTitle: 'Digital Experience Checkup -DEC - Purchase',
            timeIssue: 1702214786,
            timeDue: 1702322786,
            amountBilled: 195,
            amountPaid: 195,
            demo: true
        },
        {
            id: 116,
            currency: 'USD',
            firstName: 'Fahim',
            lastName: 'Hossain',
            phone: '8801795617763',
            email: 'yeasinn2002@gmail.com',
            invoiceTitle: 'Digital Experience Checkup -DEC - Purchase',
            timeIssue: 1702283006,
            timeDue: 1702391006,
            amountBilled: 1560,
            amountPaid: 0,
            demo: true
        }
    ],
    payments: [
        {
            id: 45,
            invoiceId: 106,
            currency: 'USD',
            amount: 240,
            timeInitiate: 0,
            timeSuccess: 0,
            demo: true
        },
        {
            id: 46,
            invoiceId: 107,
            currency: 'USD',
            amount: 195,
            timeInitiate: 0,
            timeSuccess: 0,
            demo: true
        },
        {
            id: 49,
            invoiceId: 109,
            currency: 'USD',
            amount: 0,
            timeInitiate: 1702277866,
            timeSuccess: 1702277866,
            demo: true
        }
    ],
    supportTickets: [
        {
            id: 19,
            subject: 'Subscription Issue',
            status: 'open',
            department: 'technical',
            havingAttachment: false,
            isUrgent: true,
            subscriptionId: 101,
            lastMessage: 'refhgytrrefhgytrrefhgytr',
            timeCreated: 1703924392,
            timeUpdated: 1703939474,
            demo: true
        }
    ],

    demo: true
};

export default null;
